import type { Position } from '../types/NavigationPane'

export const DASHBOARD_ID = 'dashboard'
export const COACH_AI_ID = 'coach_ai'

export const NavigationPaneFillColor = 'rgba(255, 255, 255, 0.20)'
export const NavigationPaneActiveFillColor = '#AAB6CD'

export const defaultConfig = {
  position: 'left' as Position,
  canExpand: false,
  showSettings: false,
  showAuth: true,
  isLoggedIn: false,
  showCoachAI: true
}
